import { StatusBar } from 'expo-status-bar';
import {  Image,  StyleSheet, Text, View, ActivityIndicator, TextInput, useWindowDimensions, TouchableOpacity } from 'react-native';
import logo from './../assets/logo-psihomaestru-3.png'; 
import { Ionicons } from '@expo/vector-icons';
import { AntDesign } from '@expo/vector-icons';  

import React, {useState, useEffect} from 'react';

import 'react-native-get-random-values';


export default function Welcome({navigation, route}) {

  const { tokenKey } = route.params;
  const { PUN_utilizatorID } = route.params;
  const { Nume } = route.params;
  const { preNume } = route.params;
  const { notFound } = route.params;

  let [name, setName] = useState('');
  const windowHeight = useWindowDimensions().height;
  const [shouldShowMandatory, setShouldShowMandatory] = useState(false);
  const [isLogged, setisLogged] = useState(false);
  const [isnotLogged, setisnotLogged] = useState(true);
  // const video = React.useRef(null);
  // const [status, setStatus] = React.useState({});

  const [isLoading, setLoading] = useState(true);

  //Put method to utilizatori
  let [utilizatorID, setutilizatorID] = useState('');
  let [U_status, setU_Status] = useState('');
  const PutNameUtilizator = async  () => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator', {
        method:'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "PreNume": name,
            "ultimaLogare": currentDate,
            "status": 1
          }
        )
      }
      )
      const json = await response.json();
      console.log();
      setutilizatorID(json.utilizatorID);
      setU_Status(json.status);
      setLoading(true);
      navigation.replace('Intrebari',
      {
        PUN_utilizatorID:json.utilizatorID,
        PUN_U_Status:json.status,
        tokenKey:tokenKey,
        name:name
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  
  const checkTextInput = () => {
    //Check for the Name TextInput
    if (!name.trim()) {
      setShouldShowMandatory(true);
      return;
    }
    setShouldShowMandatory(false);
    if (U_status == 1) {
      navigation.replace('Intrebari',
      {
        PUN_utilizatorID:utilizatorID,
        PUN_U_Status:U_status,
        tokenKey:tokenKey,
        name:name
      });
      return;
    }
    PutNameUtilizator();
  };



  //Get current Date, set expiration date
  const [currentDate, setCurrentDate] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  useEffect(() => {


    var date = new Date().getDate(); //Current Date
    var month = new Date().getMonth() + 1; //Current Month
    var year = new Date().getFullYear(); //Current Year
    var hours = new Date().getHours(); //Current Hours
    var min = new Date().getMinutes(); //Current Minutes
    var sec = new Date().getSeconds(); //Current Seconds
    setCurrentDate(
      year + '-' + month  + '-' + date + ' ' + hours + ':' + min + ':' + sec
    );
    setExpirationDate(
      year + '-' + month + 1 + '-' + date + ' ' + hours + ':' + min + ':' + sec
    );
    // if (PUN_utilizatorID === 'undefined'){
    //   setisnotLogged(true);
    //   setisLogged(false);
    //   return;
    // }
    if (PUN_utilizatorID !== undefined) {
      setLoading(false);
      setisLogged(true);
      setisnotLogged(false);
      return;
    }

  }, []);

  // console.log('token:'+tokenKey);
  //  console.log('currentDate:'+currentDate);
  // console.log('isLoading: '+isLoading);
  // console.log('U_status: '+ U_status);
  // console.log('PUN_utilizatorID:'+PUN_utilizatorID);
  // console.log('Nume:'+Nume);
  // console.log('preNume:'+preNume);
  // console.log('isnotLogged:'+isnotLogged);
  // console.log('isLogged:'+isLogged);
  // console.log('notFound:'+notFound);
  
 



//From here we have the page objects    
  return (
    
    <View style={styles.container}>
      
      <Image source={logo} style={styles.logo} />
      <Text style={styles.h1}>Bine ai venit!</Text>
      {isnotLogged ? (
        <View>
          <Text style={styles.MainText}>Te rog spune-mi care este numele tau?</Text>
            <TextInput 
              name='username'
              style={styles.input}
              placeholder='ex: Bogdan'
              onChangeText={(val) => setName(val) }
            />
          {shouldShowMandatory ? (
          <Text style={styles.inputMando}>Te rog sa completezi numele!</Text>
          ) : null
          }

        <TouchableOpacity
          style={styles.buttonPlay}
            onPress=
            { 
              () => {
                checkTextInput();
              }
            }
          >
            <Ionicons name="ios-play" size={24} color="#628914" />
          </TouchableOpacity>
          <Text style={styles.subText1}>Ai cont deja? Hai sa te loghezi!</Text>
          <TouchableOpacity
              style={styles.loginBtn}
              onPress={ () => {
                navigation.push('Login',
                    {
                      tokenKey:tokenKey, 
                    })}}
          >
              <AntDesign name="login" size={24} color="#628914" />
          </TouchableOpacity>
          </View>
      ) : null} 
      {isLogged ? (
        <View>
          {isLoading ? 
          ( 
            <ActivityIndicator size="large" color="#628914" style={{top: 50, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
          ) : (
          <Text style={styles.subText}>{Nume} {preNume}</Text>
            )
          }
          {isLoading ? 
          ( null 
          ) : (
          <TouchableOpacity
            style={styles.loginBtn}
            onPress={ () => {
              if (PUN_utilizatorID !== null && notFound == false) {
                navigation.replace('Contul meu',
                {
                  tokenKey:tokenKey,
                  PUN_utilizatorID:PUN_utilizatorID
                })
              } else {
              navigation.push('Login',
                  {
                    tokenKey:tokenKey, 
                  })
              }}}
          >
            <AntDesign name="login" size={24} color="#628914" />
          </TouchableOpacity>
            )
          }
        </View>
      ) : null} 
      <StatusBar style="auto" />
    </View>

  );
}

//Styles
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e9ebee',
    alignItems: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    left: 20,
    alignSelf: 'flex-start',
    width: 200, 
    height: 50,
    position: 'absolute',
    top:30,
  },
  h1: {
    fontSize: 16,
    // top: 100,
    color:"#628914"
  },
  MainText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    top: 10,
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    top: 40,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMando: {
    top: 40,
    color: 'red'
  },
  label: {
    margin: 8,
  },
  buttonPlay: {
    top:40,
    alignSelf: 'center',
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  subText1: {
    fontSize: 14,
    color: "#3E473A",
    flexShrink: 1,
    position: 'relative',
    top: 120,
  },
  subText: {
    fontSize: 14,
    color: "#3E473A",
    flexShrink: 1,
    position: 'relative',
    top: 30,
    fontWeight: 'bold',
  },
  loginBtn: {
    backgroundColor: '#EFEB88',
    top: 160,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
});

